import { LegalShell } from '../components/LegalShell.js';

export function TermsPage() {
  return (
    <LegalShell
      stamp="termos de uso"
      title="Regras do jogo"
      lastUpdated="11 de maio de 2026"
      intro={
        <p>
          Estes termos definem como você pode usar o SmartApply e o que esperar da nossa
          parte. Como o produto está em MVP e construído publicamente, alguns pontos vão
          evoluir. Mudanças significativas serão comunicadas antes de entrar em vigor.
        </p>
      }
    >
      <h2>1. Aceitação</h2>
      <p>
        Ao criar uma conta e usar o SmartApply, você concorda com estes termos e com a{' '}
        <a href="#/privacidade">Política de Privacidade</a>. Se discordar de qualquer parte,
        não use o serviço. Você pode deletar sua conta a qualquer momento.
      </p>

      <h2>2. O que é o SmartApply</h2>
      <p>
        O SmartApply é uma ferramenta que analisa o PDF do seu perfil do LinkedIn e gera
        sugestões automatizadas de melhoria (diagnóstico, reescrita de headline e summary) e
        rascunhos de posts pra publicação no LinkedIn. Toda análise é feita por modelos de
        linguagem (LLMs) de terceiros, usando a chave de API que você mesmo configura
        (modelo BYOK: Bring Your Own Key).
      </p>
      <p>
        <strong>O SmartApply não publica nada no seu LinkedIn.</strong> A gente sugere o
        texto; você decide o que copiar, ajustar e publicar.
      </p>

      <h2>3. Sua conta</h2>
      <ul>
        <li>Você é responsável pela confidencialidade da sua senha e da sua chave de IA</li>
        <li>Use uma senha única, forte, e ative 2FA na tela de Segurança</li>
        <li>Avise a gente imediatamente se suspeitar de acesso não autorizado</li>
        <li>Uma pessoa, uma conta. Sem revenda de acesso.</li>
        <li>Você precisa ter 18 anos ou mais pra usar o serviço</li>
      </ul>

      <h2>4. Uso aceitável</h2>
      <p>Você pode usar o SmartApply pra analisar e melhorar o seu próprio perfil profissional.</p>
      <p>Você não pode usar o SmartApply pra:</p>
      <ul>
        <li>Subir perfil de terceiros sem autorização clara da pessoa</li>
        <li>Tentar fraudar processos seletivos com informações falsas</li>
        <li>
          Gerar conteúdo difamatório, discriminatório, ou que viole direitos de outras
          pessoas
        </li>
        <li>Fazer engenharia reversa, scraping massivo ou abuso de rate limits</li>
        <li>
          Revender output da ferramenta como serviço próprio (ex: agência cobrando análises
          em lote sem identificar a origem)
        </li>
      </ul>

      <h2>5. Chaves de API de provedores de IA</h2>
      <p>
        Você é responsável pela sua chave de IA (Google, Anthropic ou OpenAI). Custos
        eventuais cobrados pelo provider correspondente são da sua responsabilidade. A gente
        não tem controle sobre limites de rate, mudanças de preço ou disponibilidade dos
        modelos.
      </p>
      <p>
        Quando você chama uma análise, o conteúdo parseado do seu PDF é enviado pra IA da
        sua escolha. As políticas de privacidade desses providers se aplicam a essa
        chamada.
      </p>

      <h2>6. Conteúdo gerado pela IA</h2>
      <p>
        O SmartApply usa IA pra gerar diagnóstico e rascunhos. Esse conteúdo:
      </p>
      <ul>
        <li>
          <strong>Pode conter imprecisões.</strong> Modelos de linguagem erram, inventam
          fatos, e podem repetir vieses dos dados de treino. Você é responsável por revisar
          tudo antes de aplicar.
        </li>
        <li>
          <strong>É pra uso pessoal e profissional seu.</strong> Não somos responsáveis por
          decisões tomadas com base nas sugestões geradas (vagas perdidas, oportunidades não
          aproveitadas, etc).
        </li>
        <li>
          <strong>Você pode usar comercialmente.</strong> Os textos gerados a partir do seu
          perfil são seus pra usar como quiser, incluindo publicação no LinkedIn ou outros
          canais.
        </li>
      </ul>

      <h2>7. Propriedade intelectual</h2>
      <p>
        O código-fonte do SmartApply, a marca, e a identidade visual são de propriedade dos
        responsáveis pelo projeto. Você não recebe nenhuma licença sobre eles pelo simples
        uso do serviço.
      </p>
      <p>
        O conteúdo que você sobe (PDF do perfil) e o conteúdo gerado a partir dele (análises,
        drafts) continuam seus. A gente só tem licença operacional pra processar enquanto
        você está usando.
      </p>

      <h2>8. Indisponibilidade e MVP</h2>
      <p>
        O SmartApply está em fase MVP (produto mínimo viável). Pode haver bugs,
        indisponibilidades não programadas, perda eventual de dados em ambientes de
        desenvolvimento, e mudanças significativas no produto sem aviso prévio.
      </p>
      <p>
        Não oferecemos SLA neste momento. Faça backup do que for importante (use o botão
        "exportar análise" quando estiver disponível).
      </p>

      <h2>9. Cancelamento e exclusão</h2>
      <p>
        Você pode deletar sua conta a qualquer momento pela tela de Segurança da app. A
        exclusão é imediata e remove permanentemente: análises salvas, drafts de post,
        configurações, e a própria conta. Logs anonimizados de operação podem ser mantidos
        por até 30 dias por motivo de segurança.
      </p>
      <p>
        A gente pode encerrar contas que violem estes termos, especialmente as regras de
        "uso aceitável" do item 4. Avisaremos por e-mail antes, salvo em casos de abuso
        evidente.
      </p>

      <h2>10. Limitação de responsabilidade</h2>
      <p>
        Na máxima extensão permitida pela legislação brasileira: o SmartApply não se
        responsabiliza por danos indiretos, lucros cessantes ou perda de oportunidades
        decorrentes de decisões tomadas com base no conteúdo gerado pela ferramenta.
      </p>
      <p>
        Esta limitação não exclui responsabilidade por dolo ou culpa grave nossa, conforme o
        Código de Defesa do Consumidor.
      </p>

      <h2>11. Mudanças nestes termos</h2>
      <p>
        Quando algo material mudar, atualizamos a data no topo deste documento e avisamos
        por e-mail (se você verificou) pelo menos sete dias antes da mudança valer. Se você
        não concordar, pode deletar a conta antes disso.
      </p>

      <h2>12. Lei aplicável e foro</h2>
      <p>
        Estes termos são regidos pelas leis da República Federativa do Brasil. Foro da
        comarca do domicílio do consumidor pra disputas envolvendo relação de consumo,
        conforme CDC.
      </p>

      <blockquote>
        Versão inicial. O comportamento técnico do produto descrito aqui é o que de fato
        acontece hoje. Pra qualquer dúvida sobre estes termos, escreva pra{' '}
        <a href="mailto:contato@smartapply.com.br">contato@smartapply.com.br</a>.
      </blockquote>
    </LegalShell>
  );
}
